import {
  CoinsStacked01Icon,
  File05Icon,
  FormMenuIcon,
  InfoPageIcon,
  Link03Icon,
  Mail05Icon,
  ShoppingCartCheckIcon,
  ShoppingCartIcon,
  TrendDown01Icon,
  TrendUp01Icon,
  Tv02Icon,
  UserCheck01Icon,
  UserPlus01Icon,
  WebinarIcon,
  WebinarPlayIcon,
} from '@systemeio/icons'
import { FunnelStepTypeEnum } from 'shared/enums/funnel-step-type-enum'

export const getFunnelStepTypeIcon = (funnelStepType: FunnelStepTypeEnum) => {
  const iconClassName = 'size-7 shrink-0'

  switch (funnelStepType) {
    case FunnelStepTypeEnum.OrderThankYouPage:
      return <ShoppingCartCheckIcon className={iconClassName} />
    case FunnelStepTypeEnum.OfferForm:
      return <ShoppingCartIcon className={iconClassName} />
    case FunnelStepTypeEnum.Upsell:
      return <TrendUp01Icon className={iconClassName} />
    case FunnelStepTypeEnum.Downsell:
      return <TrendDown01Icon className={iconClassName} />
    case FunnelStepTypeEnum.Squeeze:
      return <UserPlus01Icon className={iconClassName} />
    case FunnelStepTypeEnum.SalesPage:
      return <CoinsStacked01Icon className={iconClassName} />
    case FunnelStepTypeEnum.InfoPage:
      return <InfoPageIcon className={iconClassName} />
    case FunnelStepTypeEnum.OptInThankYouPage:
      return <UserCheck01Icon className={iconClassName} />
    case FunnelStepTypeEnum.Inline:
      return <File05Icon className={iconClassName} />
    case FunnelStepTypeEnum.Popup:
      return <FormMenuIcon className={iconClassName} />
    case FunnelStepTypeEnum.WebinarRegistration:
      return <Tv02Icon className={iconClassName} />
    case FunnelStepTypeEnum.WebinarThankYou:
      return <WebinarIcon className={iconClassName} />
    case FunnelStepTypeEnum.WebinarSession:
      return <WebinarPlayIcon className={iconClassName} />
    case FunnelStepTypeEnum.ContactUsPage:
      return <Mail05Icon className={iconClassName} />
    case FunnelStepTypeEnum.LinkInBio:
      return <Link03Icon className={iconClassName} />
    default:
      return
  }
}
